<template>
	<div class="head mb-2">
		<div class="p-3">Skill Assessment</div>
		<hr class="m-0" />
	</div>
	<div class="columns container mb-4">
		<div class="column is-full-mobile is-half-desktop">
			<div class="quiz-image mb-4">
				<dynamic-image :image="quizImage"></dynamic-image>
			</div>
			<div class="is-full">
				<div class="has-text-centered bold-text is-size-5 mb-5">Appliance Repair Skill Assessment</div>
				<div class="has-text-centered">
					<span class="info-item p-3 is-radius-3 has-text-primary mx-2">
						<img src="@/assets/images/skill-assessment/icons/clock.svg"/>
						<div class="medium-text">{{ quizTime }} Minutes</div>
					</span>
					<span class="info-item p-3 is-radius-3 has-text-primary mx-2">
						<img src="@/assets/images/skill-assessment/icons/question.svg"/>
						<div class="medium-text">{{ questionsPerQuiz }} Questions</div>
					</span>
				</div>
			</div>
		</div>
		<quiz-info></quiz-info>
	</div>
	<div class="cta has-text-centered p-3">
		<div class="mb-4 px-3">
			<button class="is-primary button is-fullwidth py-3 medium-text" @click="start">Start Assessment</button>
		</div>
		<div>
			<span class="disclaimer is-size-6">
				By starting this assessment, you agree to complete it honestly and without external assistance.
			</span>
		</div>
	</div>

	<br />
	<br />
	<br />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';
import { STATE_MODULES } from '@/store/state-modules';
import { QuizGetters } from '@/store/modules/quiz/getters';
import { QuizActions } from '@/store/modules/quiz/actions';
import QuizInfo from '../helpers/QuizInfo.vue';
import DynamicImage from '@/components/ui/hoc/DynamicImage.vue'
export default defineComponent({
	computed: {
		...mapGetters(STATE_MODULES.QUIZ, {
			quizImage: QuizGetters.GET_QUIZ_IMAGE,
			quizTime: QuizGetters.GET_QUIZ_TIME,
			questionsPerQuiz: QuizGetters.GET_QUESTIONS_COUNT
		})
	},
	methods: {
		start () {
			this.$store.dispatch(`${STATE_MODULES.QUIZ}/${QuizActions.START_QUIZ}`, {});
		}
	},
	components: {
		QuizInfo, DynamicImage
	}
})
</script>

<style scoped>
	.head hr {
		background: #d4d4d4;
	}

	.container{
		max-width: 1000px;
		margin: 0 auto;
	}

	.info-item{
		display: inline-block;
		border: 2px solid;
		min-width: 100px;
	}
	.info-item img {
		height: 25px;;
	}

	.disclaimer{
		color: #B5B6BA;
	}

	.cta{
		max-width: 500px;
		margin: 0 auto;
	}
</style>
